@if (!hide) {
<div class="navbar">
  <div class="navbar-inner">

    <div class="head-drop">
      <!-- <button mat-icon-button (click)="sidebarService.toggleSidebar()">
        <mat-icon>menu</mat-icon>
      </button> -->

      <button class="mobile-menu-toggle" mat-icon-button (click)="sidebarService.toggleMobileSidebar()">
        <mat-icon>menu</mat-icon>
      </button>

      @if (heading && !showBoards) {
      <div class="heading">
        {{ heading }} 
      </div>
      }
      @if (showBoards) {
      <div class="boards">
        <button mat-button [matMenuTriggerFor]="boardMenu" class="board-selector">
          <div class="current-board">
            @if (currentBoard?.projectIcon) {
            <div class="board-icon">
              <img [src]="currentBoard?.projectIcon" alt="Board Icon">
            </div>
            } @else {
            <div class="board-icon default-icon">
              <mat-icon>dashboard</mat-icon>
            </div>
            }
            <span class="board-name">{{ currentBoard?.name || 'Select Board' }}</span>
            <mat-icon>arrow_drop_down</mat-icon>
          </div>
        </button>
        
        <mat-menu #boardMenu="matMenu" class="board-menu">
          @for (item of boards; track item.key) {
          <button mat-menu-item (click)="boardSelected(item)" class="board-menu-item">
            <div class="board-menu-content">
              @if (item.projectIcon) {
              <div class="board-icon">
                <img [src]="item.projectIcon" alt="Board Icon">
              </div>
              } @else {
              <div class="board-icon default-icon">
                <mat-icon>dashboard</mat-icon>
              </div>
              }
              <span>{{ item.name }}</span>
            </div>
          </button>
          }
        </mat-menu>
      </div>
      }
    </div>

    @if (showSearch && heading) {
    <div class="search-wrapper">
      <app-search></app-search>
    </div>
    }

    @if(runningTimers && runningTimers.length > 0) {
      <div class="time-sheets">
        @for (item of runningTimers; track item) {
          <div class="time-sheet" (click)="editItem(item)" [title]="item.notes">
            <div class="timer-circle">
              <mat-icon>timer</mat-icon>
              <span>{{ formatMinutes(item.total) }}</span>
            </div>
          </div>
        }
      </div>
    }

    <div class="links-wrapper">
      <app-profile-menu (notificationsClicked)="notificationsClicked()"  (prioritiesClicked)="prioritiesClicked()"  (chatClicked)="openChatModal()"  (profileClicked)="profileClicked()" [chats]="chats" [priorities]="priorities.length" [notifications]="totalNotifcations"  [user]="user" ></app-profile-menu>

    </div>
  </div>
</div>
}
